








// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import { AloPageContent, getDefaultAloPageContent } from '@/models/alo/AloPageContent';

@Component({
  name: 'EditBaseSeo',    
   props: {
    pageContent:{      
      default:getDefaultAloPageContent()
    }
  }
})
export default class EditBaseSeo extends Vue {
  private pageContent!:AloPageContent  
}
